// Array of field configurations
import { FormField } from "./Types";

// Array of field configurations
export const formFields: FormField[] = [
    {
        label: "Category Name",
        name: "category_name",
        type: "text",
        required: "Category Name is required",
    },
    {
        label: "Status",
        name: "status",
        type: "select",
        options: [
            { value: 1, label: "Active" },
            { value: 0, label: "Inactive" },
        ],
        required: "Category Name is required",
    },
];

export const breadcrumbItems = [{ label: "Category", link: "/auth/category" }];
